<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { ref, watchEffect } from "vue";

const props = defineProps(["class", "style", "innerClass", "innerStyle", "error", "label", "tooltip", "modelValue"]);

defineEmits(["update:modelValue"]);

const textarea = ref(null);

watchEffect(() => {
	if (textarea.value)
		textarea.value.setCustomValidity(typeof props.error !== "undefined" ? props.error : "");
});
</script>

<template>
	<label :class="class" :style="style" class="vui-textarea">
		<template v-if="label">
			<span class="label">{{ label }}</span>
			<span v-if="!$attrs.required && $attrs.required !== ''" class="badge">{{ $gettext("optional") }}</span>
			<i v-if="tooltip || $slots.tooltip" class="fa-solid fa-square-info tooltip tooltip-right" @click.prevent>
				<div class="tooltip-content"><slot name="tooltip">{{ tooltip }}</slot></div>
			</i>
		</template>
		<textarea
			ref="textarea"
			:class="innerClass"
			:style="innerStyle"
			:value="modelValue"
			v-bind="$attrs"
			@change="$emit('update:modelValue', $event.target.value.trim()); $forceUpdate()"
		/>
	</label>
</template>
